// extracted by css-extract-rspack-plugin
export default {"container":"_b60f37a5","title":"_f136a602","titleTop":"_8403cc9","instructionalText":"_7424766a","supportCenterLink":"_40b2dec6","primaryCta":"_cee925b8"};